import React from 'react';
import { createRoot } from 'react-dom/client';
import '@robinpowered/ui-kit/fonts.css';
import './lib/sentry';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { App } from 'App';
import { useImportMapReady } from './hooks/useImportMapReady';

// Component to handle import map loading and app registration
const AppInitializer: React.FC = () => {
  useImportMapReady();
  return <App />;
};

const container = document.getElementById('root');
if (!container) {
  throw new Error('Failed to find the root element');
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <AppInitializer />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
